"use client";
import Image from "next/image";
import { useState } from "react";
import { BlogListType } from "@/@core/enums/blog.enum";

interface Props extends Blog {}

export default function BlogThumbnail(props: Props) {
  const [hasError, setHasError] = useState(false);
  const image = props?.descriptions?.[0]?.featured_image;

  const getSrc = () => {
    return `blog/${props?.id}/${image}`;
  };

  if (!image) return null;

  if (hasError) return null;

  return (
    <Image
      src={getSrc()}
      alt={props.descriptions?.[0]?.title}
      width={500}
      height={500}
      className="rounded-md"
      fetchPriority={
        props.list_type == BlogListType.FIRST_TEXT ? "high" : "low"
      }
      priority={props.list_type == BlogListType.FIRST_TEXT}
      onError={() => setHasError(true)}
    />
  );
}
